import { BeneficiaryModel } from './../../../../model/beneficiary.model';
import { createAction } from '@ngrx/store';
import { props } from '@ngrx/store';

export const RequestAction = createAction('[Beneficiaries view] get data', props<{ accountId: number }>());
export const ResponseAction = createAction('[Beneficiaries view] set data',  props<{ payload: BeneficiaryModel[] }>());



